export const desSessionCookie = 'des_session';
export const authHeader = 'Authorization';
export const sitesUrl = 'sites';
export const tariffsUrl = 'tariffs';
export const tariffsNameUrl = 'tariff-names';
export const developersUrl = 'developers';
export const accountsUrl = 'accounts';
export const availableUtilitiesUrl = 'available-utilities';
export const utilityUrl = 'utility';
export const utilitiesUrl = 'utilities';
export const versionUrl = 'version';
export const serviceUrl = 'info';
export const programUrl = 'programs';
export const dispatchStatusUrl = 'dispatch-status';
export const maxOutputUrl = 'max-output';
export const maxEnergyUrl = 'max-energy';
export const dispatchUrl = 'dispatches';
export const devicesUrl = 'devices';
export const batteriesUrl = 'batteries';
export const predictedOutputUrl = 'predicted-output';
export const statisticsUrl = 'statistics';
export const combinedDemandUrl = 'combined-demand';
export const dersUrl = 'stores';
export const optimizationUrl = 'optimization';
export const chargesUrl = 'charges';
export const DEMAND_RESPONSE = 'DEMAND_RESPONSE';
export const COINCIDENT_PEAK = 'COINCIDENT_PEAK';
export const DENSTORE = 'DEN-STORE';
export const SOLAR = 'SOLAR';
export const FUELCELL = 'FUEL-CELL';
export const probabilityUrl = 'probability';
export const loadForecastUrl = 'load-forecast';
export const coincidentPeakUrl = 'coincident-peak';
export const cancelStatus = 'cancel';
export const saveStatus = 'save';
export const errorStatus = 'error';
export const DISPATCH_ACTIVE = 'ACTIVE';
export const DISPATCH_COMPLETE = 'COMPLETE';
export const DISPATCH_ERROR = 'ERROR';
export const DISPATCH_PENDING = 'PENDING';
export const BULK_CHARGE = 'BULK_CHARGE';
export const BULK_GENERATE = 'BULK_GENERATE';
export const DEMAND_SETPOINT = 'DEMAND_SETPOINT';
export const AUTOMATIC_OPTIMIZATION = 'AUTOMATIC_OPTIMIZATION';
export const IDLE = 'IDLE';
export const UNKNOWN = 'UNKNOWN';
export const UNAVAILABLE = 'UNAVAILABLE';
export const HOBBLED = 'HOBBLED';
export const ALARM = 'ALARM';
export const PAUSED = 'PAUSED';
export const SITE_STATUS_NON_ACTIVE = 'NON_ACTIVE';
export const SITE_STATUS_CRITICAL = 'CRITICAL';
export const SITE_STATUS_UNDER_PERFORMING = 'UNDER_PERFORMING';
export const SITE_STATUS_PERFORMING = 'PERFORMING';
export const SITE_STATUS_ACTIVE = 'ACTIVE';
export const SITE_STATUS_NORMAL = 'NORMAL';
export const DISPATCH_TIME_BOUNDARY = 24;
export const DEFAULT_UNIT = 'kW';
export const NORMAL = 'NORMAL';
export const BULKCHARGE = 'BulkCharge';
export const BULKGENERATE = 'BulkGenerate';
export const PLANNED_POWER_CRITICAL = 'PLANNED_POWER_CRITICAL';
export const PLANNED_POWER_UNDERPERFORMING = 'PLANNED_POWER_UNDERPERFORMING';
export const ACTUAL_POWER_CRITICAL = 'ACTUAL_POWER_CRITICAL';
export const ACTUAL_POWER_UNDERPERFORMING = 'ACTUAL_POWER_UNDERPERFORMING';
export const UNKNOWN_SITE_DISPATCH_STATUS = 'UNKNOWN_SITE_DISPATCH_STATUS';
export const UNKNOWN_ACTIVITY_STATUS = 'UNKNOWN_ACTIVITY_STATUS';
export const GENERATING_NOT_CHARGING = 'GENERATING_NOT_CHARGING';
export const CHARGING_NOT_GENERATING = 'CHARGING_NOT_GENERATING';
export const BAD_SITE_STATE = 'BAD_SITE_STATE';
export const BAD_DER_STATE = 'BAD_DER_STATE';
export const PLANNED_POWER = 'plannedPower';
export const UTC_TIMEZONE = 'UTC';
export const NOT_AUTOMATIC_GENERATION = 'NOT_AUTOMATIC_GENERATION';
export const INADEQUATE_ENERGY_FOR_MANEUVER_DURATION = 'INADEQUATE_ENERGY_FOR_MANEUVER_DURATION';
export const MANEUVER_NOT_FOUND = 'MANEUVER_NOT_FOUND';
export const NOT_AUTOMATIC_OPTIMIZATION = 'NOT_AUTOMATIC_OPTIMIZATION';
export const programTypes =
  [
    {
      key: 'COINCIDENT_PEAK',
      value: 'Coincident Peak'
    },
    {
      key: 'DEMAND_RESPONSE',
      value: 'Demand Response',
    },
    {
      key: 'RESERVES',
      value: 'Reserves'
    }
  ];

export const pointOfMeasurement = [
  {
    key: 'UTILITY_METER',
    value: 'Utility Meter'
  },
  {
    key: 'BATTERY_METER',
    value: 'Battery Meter'
  }
];

export const performanceTarget = [
  {
    key: 'BASELINE',
    value: 'Baseline',
  },
  {
    key: 'REAL_TIME_OUTPUT',
    value: 'Real Time Output'
  }
];
